import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import eleven from '../assets/svg/projects/eleven.svg'
import ten from '../assets/svg/projects/ten.svg'

export const projectsData = [
    // {
    //     id: 1,
    //     projectName: 'Employee Management',
    //     projectDesc: 'This project aims to build an employee management system that consolidates all information of a company',
    //     tags: ['React', 'CSS', 'Material Ui'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: one
    // },
    {
        id: 1,
        projectName: 'StreamVerse',
        projectDesc: 'StreamVerse, a video streaming platform featuring real-time chat via Socket.io, user authentication, video uploads, search, trending content, playlists, and collaborative viewing rooms.',
        tags: ['React', 'NodeJS', 'MongoDB'],
        code: 'https://github.com/ved-rajpoot/Streamverse',
        demo: 'https://github.com/ved-rajpoot/Streamverse',
        image: ten
    },
    {
        id: 2,
        projectName: 'Quizzer',
        projectDesc: 'Quizerr, an online quizzing platform with user authentication, quiz creation, leaderboards, and analytics dashboards for teachers to track student performance.',
        tags: ['React', 'NodeJS', 'Firebase'],
        code: 'https://github.com/ved-rajpoot/QuizApp',
        demo: 'https://github.com/ved-rajpoot/QuizApp',
        image: eleven
    },
    // {
    //     id: 3,
    //     projectName: 'Weather App',
    //     projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
    //     tags: ['Django', 'CSS', 'Material Ui'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: three
    // },
    // {
    //     id: 4,
    //     projectName: 'Android Patient Tracker',
    //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
    //     tags: ['Flutter', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: four
    // },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/